import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarFooter,
  useSidebar,
} from "@/components/ui/sidebar";
import { Button } from "./ui/button";
import { supabase } from "@/integrations/supabase/client";
import { SidebarLogo } from "./sidebar/SidebarLogo";
import { SidebarNavigation } from "./sidebar/SidebarNavigation";
import { SidebarUserProfile } from "./sidebar/SidebarUserProfile";
import { SidebarSocialLinks } from "./sidebar/SidebarSocialLinks";

export function AppSidebar() {
  const [username, setUsername] = useState<string>("");
  const { toggleSidebar, state } = useSidebar();

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (user) {
      const { data } = await supabase
        .from('profiles')
        .select('username, linkedin_profile_url')
        .eq('id', user.id)
        .single();
      
      if (data?.username) {
        setUsername(data.username);
      }
    }
  };

  return (
    <Sidebar className="bg-sidebar-background border-sidebar-border" collapsible="icon">
      {state !== "collapsed" && (
        <div className="absolute right-2 top-2 z-50">
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6"
            onClick={toggleSidebar}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
        </div>
      )}
      <SidebarContent>
        <SidebarGroup>
          <SidebarLogo />
          <SidebarGroupContent>
            <SidebarNavigation />
            {state === "collapsed" && (
              <div className="flex justify-center mt-4">
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-6 w-6"
                  onClick={toggleSidebar}
                >
                  <ChevronRight className="h-4 w-4" />
                </Button>
              </div>
            )}
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="border-t border-sidebar-border">
        <SidebarUserProfile 
          username={username} 
          isCollapsed={state === "collapsed"} 
        />
        {state !== "collapsed" && <SidebarSocialLinks />}
      </SidebarFooter>
    </Sidebar>
  );
}